// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe53d29f","455":"7534420e"}[chunkId] + ".chunk.js";
};